import * as types from "../actions/actionTypes";

const initialState = {
  contactAs: [],
};

const contactAs = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_CONTACT_AS_RESPONSE:
      return { ...state, contactAs: action.payload };
    case types.GET_ALL_CONTACT_AS:
      return { ...state, contactAs: []};
    default:
      return state;
  }
};

export default contactAs;
